var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransform2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4613_25762",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4613_25762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22.5H42.5V17.5H17.5V22.5ZM17.5 32.5H29.375C30.2083 31.5 31.1146 30.5729 32.0938 29.7188C33.0729 28.8646 34.1458 28.125 35.3125 27.5H17.5V32.5ZM17.5 42.5H25.125C25.2083 41.625 25.3646 40.7708 25.5938 39.9375C25.8229 39.1042 26.1042 38.2917 26.4375 37.5H17.5V42.5ZM12.5 52.5C11.125 52.5 9.94792 52.0104 8.96875 51.0312C7.98958 50.0521 7.5 48.875 7.5 47.5V12.5C7.5 11.125 7.98958 9.94792 8.96875 8.96875C9.94792 7.98958 11.125 7.5 12.5 7.5H47.5C48.875 7.5 50.0521 7.98958 51.0312 8.96875C52.0104 9.94792 52.5 11.125 52.5 12.5V26.4375C51.7083 26.1042 50.8958 25.8229 50.0625 25.5938C49.2292 25.3646 48.375 25.2083 47.5 25.125V12.5H12.5V47.5H25.125C25.2083 48.375 25.3646 49.2292 25.5938 50.0625C25.8229 50.8958 26.1042 51.7083 26.4375 52.5H12.5ZM45 57.5C41.9583 57.5 39.3021 56.5521 37.0312 54.6563C34.7604 52.7604 33.3333 50.375 32.75 47.5H36.625C37.1667 49.3333 38.1979 50.8333 39.7188 52C41.2396 53.1667 43 53.75 45 53.75C47.4167 53.75 49.4792 52.8958 51.1875 51.1875C52.8958 49.4792 53.75 47.4167 53.75 45C53.75 42.5833 52.8958 40.5208 51.1875 38.8125C49.4792 37.1042 47.4167 36.25 45 36.25C43.7917 36.25 42.6667 36.4688 41.625 36.9062C40.5833 37.3438 39.6667 37.9583 38.875 38.75H42.5V42.5H32.5V32.5H36.25V36.0625C37.375 34.9792 38.6875 34.1146 40.1875 33.4688C41.6875 32.8229 43.2917 32.5 45 32.5C48.4583 32.5 51.4062 33.7188 53.8438 36.1563C56.2812 38.5938 57.5 41.5417 57.5 45C57.5 48.4583 56.2812 51.4062 53.8438 53.8438C51.4062 56.2812 48.4583 57.5 45 57.5Z",
    fill: "#FF595E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransform2);
export default __webpack_public_path__ + "static/media/transform2.0ea9e889ad729f0d878cc016e79b20bf.svg";
export { ForwardRef as ReactComponent };